import React from 'react';
import { Label } from '../ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { SideSelector } from './ExamFormControls';

const GaitPostureSection = ({ formData, handleChange, readOnly }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-3">
          <Label className="text-[#2A2C2A] font-medium">Posture</Label>
          <Select
            value={formData.posture}
            onValueChange={(v) => {
              handleChange('posture', v);
              if (v === 'normal') handleChange('posture_side', '');
            }}
            disabled={readOnly}
          >
            <SelectTrigger className="bg-[#F8F7F4] border-[#E5E4E0]" data-testid="posture-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="normal">Normal</SelectItem>
              <SelectItem value="wide_based">Wide-based stance</SelectItem>
              <SelectItem value="head_tilt">Head tilt</SelectItem>
              <SelectItem value="head_turn">Head turn</SelectItem>
              <SelectItem value="kyphosis">Kyphosis</SelectItem>
              <SelectItem value="decerebrate">Decerebrate rigidity</SelectItem>
              <SelectItem value="decerebellate">Decerebellate rigidity</SelectItem>
              <SelectItem value="unable_to_evaluate">Unable to Evaluate</SelectItem>
            </SelectContent>
          </Select>
          <SideSelector field="posture" show={formData.posture !== 'normal'} formData={formData} handleChange={handleChange} readOnly={readOnly} />
        </div>
        <div className="space-y-3">
          <Label className="text-[#2A2C2A] font-medium">Gait</Label>
          <Select
            value={formData.gait}
            onValueChange={(v) => {
              handleChange('gait', v);
              if (v === 'normal') {
                handleChange('gait_side', '');
                handleChange('gait_lf', '');
                handleChange('gait_rf', '');
                handleChange('gait_lh', '');
                handleChange('gait_rh', '');
              }
            }}
            disabled={readOnly}
          >
            <SelectTrigger className="bg-[#F8F7F4] border-[#E5E4E0]" data-testid="gait-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="normal">Normal</SelectItem>
              <SelectItem value="ataxia">Ataxia</SelectItem>
              <SelectItem value="paresis">Paresis</SelectItem>
              <SelectItem value="plegia">Plegia</SelectItem>
              <SelectItem value="circling">Circling</SelectItem>
              <SelectItem value="hypermetria">Hypermetria</SelectItem>
              <SelectItem value="unable_to_evaluate">Unable to Evaluate</SelectItem>
            </SelectContent>
          </Select>
          {formData.gait !== 'normal' && (
            <div className="space-y-2" data-testid="gait-limb-selector">
              <span className="text-xs text-[#5C5F5C]">Affected limbs:</span>
              <div className="grid grid-cols-2 gap-2">
                {[
                  { field: 'gait_lf', label: 'Left Front' },
                  { field: 'gait_rf', label: 'Right Front' },
                  { field: 'gait_lh', label: 'Left Hind' },
                  { field: 'gait_rh', label: 'Right Hind' },
                ].map(({ field, label }) => (
                  <button
                    key={field}
                    type="button"
                    disabled={readOnly}
                    onClick={() => !readOnly && handleChange(field, formData[field] ? '' : 'affected')}
                    className={`px-3 py-1.5 text-xs rounded transition-all text-left ${
                      formData[field]
                        ? 'bg-[#C06144] text-white'
                        : 'bg-white border border-[#E5E4E0] text-[#5C5F5C] hover:bg-[#F8F7F4]'
                    } ${readOnly ? 'cursor-default opacity-80' : ''}`}
                    data-testid={`gait-${field}`}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {(formData.gait === 'ataxia' || formData.gait === 'hypermetria') && (
        <div className="space-y-3">
          <Label className="text-[#2A2C2A] font-medium">Ataxia Type</Label>
          <Select value={formData.ataxia_type} onValueChange={(v) => handleChange('ataxia_type', v)}>
            <SelectTrigger className="bg-[#F8F7F4] border-[#E5E4E0]" data-testid="ataxia-select">
              <SelectValue placeholder="Select ataxia type" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="proprioceptive">Proprioceptive (General proprioceptive)</SelectItem>
              <SelectItem value="vestibular">Vestibular</SelectItem>
              <SelectItem value="cerebellar">Cerebellar</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};

export default GaitPostureSection;
